import { render, staticRenderFns } from "./SlideExam.vue?vue&type=template&id=70c93fac&scoped=true"
import script from "./SlideExam.vue?vue&type=script&lang=js"
export * from "./SlideExam.vue?vue&type=script&lang=js"
import style0 from "./SlideExam.vue?vue&type=style&index=0&id=70c93fac&prod&scoped=true&lang=css"
import style1 from "./SlideExam.vue?vue&type=style&index=1&id=70c93fac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c93fac",
  null
  
)

export default component.exports